import type { NextRouter } from 'next/router'
import { useRouter as useNextRouter } from 'next/router'
import { useMemo } from 'react'

export type Router = NextRouter & {
  hash: string
}

export const decodeQueryParam = (value: string): string =>
  decodeURIComponent(value.replace(/\+/g, ' '))

export const parseQueryParams = <T extends object>(url: string): Partial<T> => {
  const splitUrl = url.split('?')
  const query = splitUrl[splitUrl.length - 1]

  return (
    query?.split('&').reduce<T>((acc, item) => {
      const [key, value] = item.split('=')

      if (key && value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ;(acc as any)[key] = decodeQueryParam(value)
      }

      return acc
    }, {} as T) ?? {}
  )
}

export default function useRouter(): Router {
  const nextRouter = useNextRouter()

  const router = useMemo(() => {
    return {
      ...nextRouter,
      get hash() {
        return nextRouter.asPath.split('#')[1] ?? ''
      },
    }
  }, [nextRouter])

  return router
}
